//This file will be used for component communication

import Vue from 'vue';
const EventBus = new Vue();
export default EventBus;


// WEBPACK FOOTER //
// ./src/lib/utilities/eventBus.js